// An eye's booking on the waitlist: the date picker passed in (transcluded, so it stays bound to the
// waitlist) and a button to book the surgery in the practice's calendar. Each eye is its own appointment. The calendar opens over the waitlist and closes with the appointment once it is
// booked, which is handed to onBooked for the eye's surgery date.
app.component("waitlistCalendarBooking", {
	templateUrl: "app/src/js/components/surgeryWaitlist/waitlistCalendarBooking.html",
	controller: "waitlistCalendarBookingController",
	transclude: true,
	bindings: {
		eye: "<",
		busy: "<",
		onBooked: "&",
	},
});

app.controller("waitlistCalendarBookingController", [
	"$rootScope",
	"$mdDialog",
	"Session",
	function ($rootScope, $mdDialog, Session) {
		const ctrl = this;

		ctrl.$onInit = function () {
			// The calendar opens on the entry's practice, or the first other one the user may book into when
			// they can't book there; it can be switched in the calendar. No button when there is none.
			const practices = (Session.practiceOptions || []).filter(
				(p) => Session.hasCalendar(p) && Session.hasPermissionAt(p, "SCHEDULE_APPOINTMENT_MANAGE")
			);
			const own = practices.find((p) => p.id === ctrl.eye.practice_id);
			ctrl.practiceId = (own || practices[0] || {}).id;
			ctrl.opening = false;
		};

		ctrl.eyeName = function () {
			return ctrl.eye.laterality === "OD" ? "right eye" : "left eye";
		};

		ctrl.book = function ($event) {
			if (ctrl.opening || ctrl.busy || !ctrl.practiceId) {
				return;
			}
			const eye = ctrl.eye;
			const practiceId = ctrl.practiceId;
			ctrl.opening = true;

			// Off the root scope, not this row's: the list redraws on everyone's changes, and the row going
			// would take the calendar's scope with it part-way through a booking.
			const scope = $rootScope.$new(true);
			// calendarController reads this from its scope: it opens on this practice and surgeon, and closes
			// with the appointment once it is booked.
			scope.bookingFor = {
				practiceId: practiceId,
				surgeonId: eye.created_by_user_id,
				eyeName: ctrl.eyeName(),
				procedure: eye.procedure_type,
			};

			$mdDialog
				.show({
					controller: "calendarController",
					templateUrl: "app/src/views/templates/calendar.tmpl.html",
					parent: angular.element(document.body),
					targetEvent: $event,
					clickOutsideToClose: false,
					// Over the waitlist, which stays open underneath
					multiple: true,
					scope: scope,
					preserveScope: false,
					resolve: {
						patientId: () => eye.patient_id,
						patientName: () => eye.patient_full_name,
						selectedAppointment: () => null,
					},
				})
				.then((result) => {
					if (result && result.bookedAppointment) {
						ctrl.onBooked({ appointment: result.bookedAppointment, practiceId: practiceId });
					}
				})
				.catch(angular.noop)
				.finally(() => {
					ctrl.opening = false;
				});
		};
	},
]);
